import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  fontSize?: string;
};

const BreadcrumbLink = styled(NavLink)<Props>`
  color: ${({ theme }) => theme.palette.text.light};

  &:hover {
    color: ${({ theme }) => theme.palette.text.main};
  }

  ${({ fontSize }) => fontSize && `font-size: ${fontSize}em`}
`;

export default BreadcrumbLink;
